var React = require('react');

function Td (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#000067","d":"M0 0h214v480H0z","key":0}),React.createElement("path",{"fill":"red","d":"M426 0h214v480H426z","key":1}),React.createElement("path",{"fill":"#ff0","d":"M214 0h212v480H214z","key":2})]));
}

Td.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Td;

Td.default = Td;
